import * as React from "react";
import { ActionType } from "../../react-core/Flux/ActionType";
import { CommonHelper } from "../../react-core/Helpers/CommonHelper";
import { BaseComponent } from "../../react-core/Html/BaseComponent";
import { AccountByAccountNumberClient } from "../../Wrap/Api/Account/AccountByAccountNumber";
import { HierarchyLevelName } from "../../Wrap/Constants/Enums/HierarchyLevelName";
import { AccountRole } from "../../Wrap/Models/Domains/Account/AccountRole";
import { InvestorType } from "../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";
import { Action } from "../Dashboard/Actions/Action";
import { AccountSearchAction } from "../Dashboard/Components/Clients/ClientRecord/Action/AccountSearchAction";
import { ConsolidatedAccountDisaptcher } from "../Dashboard/Components/Clients/PortfolioDashboard/Store/Variable";
import CoachMarkerProvider from "../Shared/CoachMarkers/CoachMarkerContext";
import { HierarchyIdHelper } from "../Shared/Common/HierarchyIdHelper";
import { PermissionAction } from "../Shared/Permission/Action/PermissionAction";
import { PermissionStore } from "../Shared/Permission/Store/Variables";
import { getQueryParameters } from "../Shared/Wizards/Entities/QueryParametersHelper";
import { clearActionMenuParams, getActionMenuParams, setActionMenuParams } from "./DLUHelper";

export class SiteLayout extends BaseComponent<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            hasPermission: PermissionStore.getData() ? true : false,
            hasAccount: !this.needAccount() ? true : false,
            hasCustomer: !this.needAccount() ? true : false,
        };
        this.subscribeToStore(PermissionStore, () => {
            if (PermissionStore.getData()) {
                this.setState({ hasPermission: true });
            }
        });
    }

    private curAcount = () => {
        const urlParams = getQueryParameters()["claccountid"];
        const cookie = getActionMenuParams()?.headaccounthierarchyId;
        return urlParams || cookie;
    };

    private needAccount = () => {
        return !CommonHelper.isNullOrEmpty(this.curAcount());
    };

    componentDidMount() {
        PermissionAction.getPermissionByClaim();

        const needAccount = this.needAccount();
        if (needAccount && getQueryParameters()["claccountid"]) {
            const client = new AccountByAccountNumberClient();
            client.get(this.curAcount().split("-")[0]).onSuccess((d) => {
                Action.getClientAccount(d.HierarchyId, () => {
                    const actionMenu = getActionMenuParams();
                    setActionMenuParams({ ...actionMenu, headaccounthierarchyId: d.HierarchyId });
                    this.setState({
                        hasAccount: true,
                    });
                    if (d.InvestorType == InvestorType.Consolidated) {
                        ConsolidatedAccountDisaptcher.dispatch({ payload: d, actionType: ActionType.Success });
                        this.setState({ hasCustomer: true });
                    }
                });
                Action.getAccountRoles(d.HierarchyId, (result: AccountRole[]) => {
                    const actionMenu = getActionMenuParams();
                    setActionMenuParams({
                        ...actionMenu,
                        levelHierarchyId: HierarchyIdHelper.toHierarchyIdString(
                            HierarchyLevelName.Customer,
                            result.find((ele) => ele.IsPrimary)?.Customer?.CustomerId
                        ),
                    });
                    this.setState({ hasCustomer: true });
                });
            });
        } else if (needAccount) {
            const account = getActionMenuParams()?.headaccounthierarchyId;
            Action.getClientAccount(account, () => {
                this.setState({ hasAccount: true });
            });
            Action.getAccountRoles(account, () => {
                this.setState({ hasCustomer: true });
            });
        }
    }

    render() {
        if (!this.state.hasPermission || !this.state.hasAccount || !this.state.hasCustomer) {return null;}

        return <CoachMarkerProvider>{this.props.children}</CoachMarkerProvider>;
    }
}
